export const TARS_BAR_CHART = "bar-chart";
export const TARS_COLUMN_CHART = "column-chart";
export const TARS_DONUT_CHART = "donut-chart";
export const TARS_STACKED_BAR_CHART = "stacked-bar-chart";

const KNOWN_TYPES = new Set<string>([
  TARS_BAR_CHART,
  TARS_COLUMN_CHART,
  TARS_DONUT_CHART,
  TARS_STACKED_BAR_CHART,
]);

export const CHART_TYPE_PICKER_OPTIONS: {
  id: string;
  label: string;
}[] = [
  { id: TARS_BAR_CHART, label: "Bar Chart" },
  { id: TARS_COLUMN_CHART, label: "Column Chart" },
  { id: TARS_DONUT_CHART, label: "Donut Chart" },
  { id: TARS_STACKED_BAR_CHART, label: "Stacked Bar Chart" },
];

export function normalizeChartType(type: string): string {
  const t = type.trim();
  return KNOWN_TYPES.has(t) ? t : TARS_COLUMN_CHART;
}

export function parseFacetCharts(
  more: Record<string, unknown> | undefined
): Array<Record<string, unknown>> {
  if (more == null) return [];
  const raw = more.charts;
  if (!Array.isArray(raw)) return [];
  return raw.filter(
    (x): x is Record<string, unknown> =>
      x != null && typeof x === "object" && !Array.isArray(x)
  );
}

export function chartTypeLabel(chartTypeId: string): string {
  const opt = CHART_TYPE_PICKER_OPTIONS.find((o) => o.id === chartTypeId);
  return opt?.label ?? chartTypeId;
}
